export type State = 'permanent_deleted' | 'deleted' | 'archived' | 'active' | 'on_hold' | 'excluded' | 'invited' | 'locked' | 'invite_failed' | 'invite_delivered'

export const mapStateToReadableStatus = (status: State): string => {
  const statusMap: { [key in State]?: string } = {
    active: 'Active', 
    excluded: 'Excluded', 
    on_hold: 'On Hold', 
    archived: 'Archived',
    deleted: 'Deleted',
    permanent_deleted: 'Permanently Deleted',
    invited: 'Invited',
    invite_failed: 'Invite Failed',
    invite_delivered: 'Invite Delivered',
    locked: 'Locked',
  }
  return statusMap[status] || ''
}
